import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import Game from '@/views/Game'
import News from '@/views/News'
import About from '@/views/About'
import Join from '@/views/Join'
import newsDetail from '@/views/newsDetail'
import Contact from '@/views/Contact'
import Tutelage from '@/views/Tutelage'
import Disputes from '@/views/Disputes'
import Privacy from '@/views/Privacy'
import Agreement from '@/views/Agreement'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: '/',
    routes: [
        {
            path: '/',
            name: 'index',
            component: index
        }, {
            path: '/game',
            name: 'Game',
            component: Game
        }, {
            path: '/news',
            name: 'News',
            component: News
        }, {
            path: '/about',
            name: 'About',
            component: About
        }, {
            path: '/join',
            name: 'Join',
            component: Join
        }, {
            path: '/newsDetail',
            name: 'newsDetail',
            component: newsDetail
        }, {
            path: '/contact',
            name: 'Contact',
            component: Contact
        } ,{//隐私政策
            path: '/agreement',
            name: 'Agreement',
            component: Agreement
        },{//家长监护
            path: '/tutelage',
            name: 'Tutelage',
            component: Tutelage
        }, {//交易纠纷
            path: '/disputes',
            name: 'Disputes',
            component: Disputes
        }, {//隐私政策
            path: '/privacy',
            name: 'Privacy',
            component: Privacy
        }
    ]
})

































// WEBPACK FOOTER //
// ./src/router/index.js